<div *ngIf="patent.inventors && !patent.inventors?.length" [innerHTML]="'fs.res.patent.noAssignedInventors' | hisUi"></div>

<div *ngIf="patent.inventors && patent.inventors.length > 0">
	<ng-container *ngIf="!showAllInventors">
		<ng-container *ngFor="let inventor of patent.inventors | slice:0:3; index as i; last as lastInventor">
			<a href="../cs.psv.frontend/person/view/{{inventor.person.id}}?showBackButton=true"
				*ngIf="inventor.hasVisibleAffiliations; else rawtext"
				class="firstLink"
				title="{{'fs.res.common.showProfileOf'|hisUi: ('fs.res.patent.Patent.inventor'| hisUi) + ' ' + inventor.person.firstname+ ' '+ inventor.person.surname}}">
				<strong>{{inventor.person.firstname}} {{inventor.person.surname}}</strong>
			</a>
			<!-- Display no link when role doesn't have right  -->
			<ng-template #rawtext>
				<strong>{{inventor.person.firstname}} {{inventor.person.surname}}</strong>
			</ng-template>
			<span *ngIf="inventor.organization">
				<!-- todo: Check if role has rights to see details of organization -->
				<span>&ngsp;({{inventor.organization.text}})</span>
			</span>
			<span>
				<!-- todo: Check if role has rights to see details of external organization -->
				<span *ngIf="inventor.researchPartner">&ngsp;({{inventor.researchPartner.defaulttext}})</span>
			</span>

			<!-- show only for the first three creators with comma, the rest is hidden by icon -->
			<span *ngIf="!lastInventor">, </span>
			<span *ngIf="2 === i && 3 < patent.inventors.length">&nbsp;{{'fs.res.publication.view.etal' | hisUi}}</span>
			<button *ngIf="2 === i && 3 < patent.inventors.length" class="icon"
				(click)="showAllInventors = true">
				<img hisImage="ARROW_DOWN_V" class="inlineicon" title="{{ ('fs.res.patent.view.showAllInventors' | hisUi) }}">
			</button>
		</ng-container>
	</ng-container>

	<ng-container *ngIf="showAllInventors">
		<ng-container *ngFor="let inventor of patent.inventors; index as i; last as lastInventor">
			<a href="../cs.psv.frontend/person/view/{{inventor.person.id}}?showBackButton=true"
				*ngIf="inventor.hasVisibleAffiliations; else rawtext"
				class="firstLink"
				title="{{'fs.res.common.showProfileOf'|hisUi: ('fs.res.patent.Patent.inventor' | hisUi) + ' ' + inventor.person.firstname + ' '+ inventor.person.surname}}">
				<strong>{{inventor.person.firstname}} {{inventor.person.surname}}</strong>
			</a>
			<!-- Display no link when role doesn't have right  -->
			<ng-template #rawtext>
				<strong>{{inventor.person.firstname}} {{inventor.person.surname}}</strong>
			</ng-template>
			<span *ngIf="inventor.organization">
				<!-- todo: Check if role has rights to see details of organization -->
				<span>&ngsp;({{inventor.organization.text}})</span>
			</span>
			<span>
				<!-- todo: Check if role has rights to see details of external organization -->
				<span *ngIf="inventor.researchPartner">&ngsp;({{inventor.researchPartner.defaulttext}})</span>
			</span>
			<span *ngIf="!lastInventor">, </span>
			<button *ngIf=" patent.inventors.length - 1 === i" class="icon"
				(click)="showAllInventors = false">
				<img hisImage="ARROW_UP_V" class="inlineicon" title="{{ ('fs.res.patent.view.showLessInventors' | hisUi) }}">
			</button>
		</ng-container>
	</ng-container>
</div>
<br />

<div *ngIf="patent.organizations">
	<small>{{'fs.res.patent.registeringOrganization' | hisUi }}</small><br />
	<ng-container *ngFor="let orgunit of patent.organizations">
		<strong *ngIf="orgunit.organization">{{orgunit.organization.text}}<br /></strong>
	</ng-container>
	<ng-container *ngFor="let orgunit of patent.organizations">
		<strong *ngIf="orgunit.researchPartner">{{orgunit.researchPartner.defaulttext}}<br /></strong>
	</ng-container>
</div>
